import type { AssetCreate, AssetDepreciationScheduleOut, AssetOut, AssetUpdate } from "@shop-ledger/shared-types";
import { apiRequest } from "../lib/apiClient";

export async function listAssets(accessToken: string, branchId?: string): Promise<AssetOut[]> {
  return apiRequest<AssetOut[]>("/assets", { accessToken, query: { branch_id: branchId } });
}

export async function createAsset(accessToken: string, body: AssetCreate): Promise<AssetOut> {
  return apiRequest<AssetOut>("/assets", { method: "POST", accessToken, body });
}

export async function updateAsset(accessToken: string, assetId: string, body: AssetUpdate): Promise<AssetOut> {
  return apiRequest<AssetOut>(`/assets/${assetId}`, { method: "PATCH", accessToken, body });
}

export async function deleteAsset(accessToken: string, assetId: string): Promise<void> {
  await apiRequest<void>(`/assets/${assetId}`, { method: "DELETE", accessToken });
}

export async function getDepreciationSchedule(accessToken: string, assetId: string): Promise<AssetDepreciationScheduleOut> {
  return apiRequest<AssetDepreciationScheduleOut>(`/assets/${assetId}/depreciation-schedule`, { accessToken });
}
